export class EmailSettings {
    public subject: string;
    public body: string;
    public attachment1: string;
}  